import { validationRules } from '../../../../../services/validation/rules/validationRules'
import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultDescription,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'

export const agentGarageRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  basicInfo: {
    constructionYear: validationRules.constructionYear,
    constructionLastModernization: validationRules.constructionLastModernization,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  costs: {
    courtageNote: validationRules.courtageNote,
    courtage: validationRules.courtage,
    baseRent: validationRules.baseRent,
    additionalCosts: validationRules.additionalCosts,
  },
  otherFacilities: {
    heightGarage: validationRules.heightGarage,
    widthGarage: validationRules.widthGarage,
    lengthGarage: validationRules.lengthGarage,
    usableArea: validationRules.usableGarageArea,
  },
  apiSearchData: defaultApiSearchData,
}
